import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';
import { ReactComponent as MinusIcon } from '../icons/minus.svg';
import { ReactComponent as PlusIcon } from '../icons/plus.svg';
import { formatBalance } from '../Utils/GlobalUtils';

const ChangeBalanceModal = ({ closeModal, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();
    
    const [balance, setBalance] = React.useState('Загрузка...');
    const [specialBalance, setSpecialBalance] = React.useState('Загрузка...');
    const [typeBalance, setTypeBalance] = React.useState('balance');
    const [amount, setAmount] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [reload, setReload] = React.useState(true);

    const [status, setStatus] = React.useState('При нажатии кнопки действие со счётом нельзя будет отменить');

    

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        
        axios.get(`/api/get-user-balances?id=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setBalance(response.data.balance);
            setSpecialBalance(response.data.special_balance);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        }).finally(() => {
            setReload(false);
        })
    }, [reload, userId]);

    const changeBalance = (action) => {
        const token = localStorage.getItem('token');
        setStatus(<Loading type='inline' />);

        if (!amount) return setStatus(<a className='mainLabelError'>Заполните поле суммы</a>);

        axios.put(`/api/change-balance`, {
            userId,
            action,
            typeBalance,
            amount,
            description
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setAmount('');
            setDescription('');
            openTimeModal('Операция записана', 'success');
            setStatus(<a>Операция записана</a>);
            onSuccess();
            setReload(true);
        })
        .catch((error) => {
            console.error(error);
            setStatus(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => {e.stopPropagation()}}>
                <div className={styles.header}>
                    <h1>Взаимодействие с балансом</h1>
                    <IconContainer Icon={XIcon} onClick={() => {closeModal(); onSuccess()}} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='radioSwitchWrapper'>
                        <label className={`radioSwitchLabel ${typeBalance === 'balance' ? 'selected' : ''}`}>
                            <input
                                type='radio'
                                name='typeSelector'
                                value='balance'
                                checked={typeBalance === 'balance'}
                                onChange={(e) => setTypeBalance(e.target.value)}
                            />
                            <span>Членские взносы</span>
                        </label>
                        <label className={`radioSwitchLabel ${typeBalance === 'specialBalance' ? 'selected' : ''}`}>
                            <input
                                type='radio'
                                name='typeSelector'
                                value='specialBalance'
                                checked={typeBalance === 'specialBalance'}
                                onChange={(e) => setTypeBalance(e.target.value)}
                            />
                            <span>Целевые взносы</span>
                        </label>
                    </div>
                    <div className='panel' style={{fontSize: '14px'}}>
                        <p>Текущий баланс:</p>
                        <span 
                            className='horizontalContainer'
                            style={typeBalance=='balance' ? {} : {opacity: '.3'}}
                        >
                            {formatBalance(balance) + ' ₽'} <p className='description'>Членские взносы</p>
                        </span>
                        <span 
                            className='horizontalContainer'
                            style={typeBalance=='specialBalance' ? {} : {opacity: '.3'}}
                        >
                            {formatBalance(specialBalance) + ' ₽'} <p className='description'>Целевые взносы</p>
                        </span>
                    </div>
                    <input 
                        type='text' 
                        value={amount} 
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                            setAmount(value);
                            }
                        }}
                        maxLength='7' 
                        placeholder='Сумма' 
                    />
                    <div>
                        <textarea 
                            cols='10' 
                            rows='10' 
                            value={description}  
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder='Описание транзакции'
                            minLength='' 
                            maxLength='150' 
                            require=''
                        >
                        </textarea>
                        <p className='description'>{description.length}/150</p>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <div className={styles.manyButtonsWrapper}>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={() => {changeBalance('-')}}
                        >
                            <IconContainer 
                                Icon={MinusIcon} 
                                isClickable={false}
                                size = '15' 
                                color = 'white' 
                                className = '' 
                            />
                            Вычесть из счёта
                        </button>
                        <span style={{width: '20px'}}></span>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={() => {changeBalance('+')}}
                        >
                            <IconContainer 
                                Icon={PlusIcon} 
                                isClickable={false}
                                size = '15' 
                                color = 'white' 
                                className = '' 
                            />
                            Записать на счёт
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangeBalanceModal;